import { type FC, isValidElement, type PropsWithChildren, type ReactNode } from 'react';

import { Icon, type IconSource } from '../Icon';
import { HStack } from '../Stack';

type Props = {
	icon?: IconSource | ReactNode;
};

export const InfoContent: FC<PropsWithChildren<Props>> = ({ icon, children }) => (
	<HStack align="center" spacing="extraTight">
		{icon &&
			(isValidElement(icon) ? icon : <Icon source={icon as IconSource} size="small" className="text-gray-400" />)}
		{children}
	</HStack>
);
